import { CKButton, CKModal, CKTextFieldNext } from 'clearkit';

import { ButtonContainer } from '~/components/unified/ButtonContainer';

import { useProspector } from '../useProspector';

export function RenameProspectList() {
  const [state, send] = useProspector();

  const isOpen = state.matches('renaming');

  const handleCancel = () => send('CANCEL');
  const handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && state.context.nameEdit) {
      send('SAVE');
    } else if (event.key === 'Escape') {
      handleCancel();
    } else {
      return;
    }
  };

  return (
    <CKModal hasHideOnEscape isVisible={isOpen}>
      <CKModal.Header>
        <CKModal.Heading>Rename list</CKModal.Heading>
      </CKModal.Header>
      <CKModal.Body className="p-8 space-y-4">
        <p className="text-base">
          Give <strong>{state.context.name}</strong> a new name.
        </p>
        <CKTextFieldNext
          autoFocus
          onChange={(value) => send('UPDATE_NAME', { value })}
          onKeyUp={handleKeyUp}
          placeholder="List name"
          value={state.context.nameEdit}
        />
      </CKModal.Body>
      <CKModal.Footer>
        <ButtonContainer>
          <CKButton isDisabled={state.matches('saving')} onClick={handleCancel}>
            Cancel
          </CKButton>
          <CKButton
            isDisabled={!state.context.name}
            onClick={() => send('SAVE')}
            variant="bold"
            variantColor="blue"
          >
            Rename list
          </CKButton>
        </ButtonContainer>
      </CKModal.Footer>
    </CKModal>
  );
}
